import { useMemo } from 'react';
import { useArticlesThemesContext } from '@/creditflowresearch/application/ArticlesAndStats/ArticlesMarketThemesContext';
import { selectAdapter } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/adapters';
import type { IRegionFilter } from '@/creditflowresearch/application/PageFilters/hooks/create/useCreateRegionFilters';
import type { IProductFilter } from '@/creditflowresearch/application/PageFilters/hooks/create/useCreateProductFilters';
import type Market from '@/creditflowresearch/domain/Market';

interface IUseFilteredGroupedThemesProps {
  currentRegion: IRegionFilter | undefined,
  currentProduct: IProductFilter | undefined,
  currentMarket: Market | null,
  subscribableRegionIds: string[],
}

export const useFilteredGroupedThemes = ({
  currentRegion,
  currentProduct,
  currentMarket,
  subscribableRegionIds,
}: IUseFilteredGroupedThemesProps) => {
  const { themes, isFetching: isThemesFetching } = useArticlesThemesContext();

  const { groupedThemes, themesIds } = useMemo(() => {
    const adapterContext = {
      themes,
      currentRegion,
      currentProduct,
      currentMarket,
      subscribableRegionIds,
    };

    const adapter = selectAdapter(adapterContext);
    return adapter.filterThemes(adapterContext);
  }, [themes, currentRegion, currentProduct, currentMarket, subscribableRegionIds]);

  return {
    groupedThemes,
    themesIds,
    themes,
    isThemesFetching,
  };
};
